export enum AttendanceStatus {
	AWAITING_RISK_CLASSIFICATION = "1001",
	AWAITING_CONSULTATION = "1002",
	RED_ROOM = "1003",
	FORWARDED_TO_MEDICATION = "1004",
	MATERNITY_CONSULTATION = "1005",
	MATERNITY_CLASSIFICATION = "1046",
	FORWARDED_TO_PROCEDURES_ROOM = "1006",
	RISK_RECLASSIFICATION = "1007",
	AWAITING_MEDICATION = "1008",
	PEDIATRIC_OBSERVATION = "1010",
	AWAITING_MATERNITY_MEDICATION = "1011",
	MATERNITY_OBSERVATION = "1012",
	MATERNITY_RETURN = "1013",
	MEDICAL_RETURN = "1014",
	EVASION_TRIAGE = "1015",
	INTERNED = "1016",
	FINISHED = "1017",
	EXTERNAL_REFERRAL = "1018",
	CALLING_ON_SCREEN = "1020",
	IN_CONSULTATION_ATTENDANCE = "1021",
	CONSULTATION_EVASION = "1022",
	EVASION = "1023",
	PATIENT_DEATH = "1024",
	ADMINISTRATIVE_DISCHARGE = "1025",
	RECLASSIFIED = "1027",
	REVALUATE_AFTER_MEDICATION = "1029",
	ATTENDED_SPA = "1028",
	ATTENDED_MATERNITY_SPA = "1030",
	AWAITING_PEDIATRIC_MEDICATION = "1031",
	RETURN_PEDIATRICS = "1032",
	ATTENDED_SPA_PEDIATRICS = "1033",
	RETURN_WITH_SADT = "1039",
	SEND_TO_ISOLATION = "1040",
	DISCHARGE_AFTER_MEDICATION = "1041",
	RETURN_AFTER_MEDICATION = "1042",
	RETURN_AFTER_MEDICATION_WITH_SADT = "1043",
	ADULT_INTERNMENT = "1044",
	PEDIATRIC_INTERNMENT = "1045",
	MATERNITY_INTERNMENT = "1047",
	DISCHARGE_AFTER_MEDICATION_MATERNITY = "1048",
	RETURN_AFTER_MEDICATION_MATERNITY = "1049",
	RETURN_WITH_SADT_MATERNITY = "1050",
	RETURN_AFTER_MEDICATION_WITH_SADT_MATERNITY = "1051",
	RETURN_AFTER_PROCEDURES = "1055",
	RETURN_AFTER_MATERNITY_PROCEDURES = "1056",
	AWAITING_ELECTIVE_LABORATORY_EXAMS = "1060",
	ELECTIVE_LABORATORY_EXAM_ATTENDED = "1061",
	EVASION_PROCEDURES = "1063",
	ADULT_OBSERVATION_HOSPITAL = "1064",
	PEDIATRIC_OBSERVATION_HOSPITAL = "1065",
	AWAITING_ELECTIVE_RADIOGRAPHY_EXAMINATION = "1066",
	ATTENDED_ELECTIVE_EXAMINATION_RADIOGRAPHY = "1067",
	INTERNMENT_MEDICAL_DISCHARGE = "1070",
	OBSERVATION_DISCHARGE = "1071",
	RED_ROOM_DISCHARGE = "1072",
	OBSERVATION = "1080",
	BRIEF_OBSERVATION = "1081",
	SURGICAL_CENTER = "1082",
	AWAITING_SURGICAL_CENTER = "1083",
	RADIOGRAPHY_EVASION = "1084",
	CODIV_19_SYMPTOMS = "1901",
	CODIV_19_SUSPECT = "1902",
	ATTENDANCE_DISCARDED = "1903",
	CASE_CONFIRMED = "1904",
	RECOVERED = "1905",
	DEATH = "1906",
	EXAMINATION_DISCARDED = "1907",
	RESIDENTIAL_INSOLATION = "1920",
	HOSPITAL_ISOLATION = "1921",
	TRANSFER = "1922",
	START_AND_CLASSIFY_COVID_19 = "1910",
	COVID_19_CLASSIFICATION = "1911",
	COVID_19_CONSULTATION = "1912",
	SPECIALTY_CONSULTATION = "1913",
	SPECIALTY_CONSULTATION_EVASION = "1914",
	SEND_FOR_ADULT_INTERNMENT = "191038",
	RETURN_WITH_SADT_COVID = "191039",
	SEND_TO_COVID_ISOLATION = "191040",
	DISCHARGE_AFTER_COVID_MEDICATION = "191041",
	RETURN_AFTER_COVID_MEDICATION = "191042",
	RETURN_AFTER_MEDICATION_WITH_SADT_COVID = "191043",
	FINISHED_COVID = "191017",
	PEDIATRIC_INTERNMENT_COVID = "191010",
	CONSULTATION_EVASION_COVID = "191022",
	AWAITING_CONSULTATION_TELEMEDICINE = "901002",
	IN_ATTENDANCE_TELEMEDICINE = "901021",
	FINISHED_HIGH_TELEMEDICINE = "901017",
	CANCELLATION_DISMISSED_TELEMEDICINE = "901903",
}

export const AttendanceStatusMessages = {
	[AttendanceStatus.AWAITING_RISK_CLASSIFICATION]: "Aguardando Classificação de Risco",
	[AttendanceStatus.AWAITING_CONSULTATION]: "Aguardando Consulta",
	[AttendanceStatus.RED_ROOM]: "Sala Vermelha (Emergencia)",
	[AttendanceStatus.FORWARDED_TO_MEDICATION]:
		"Encaminhado para Medicação (Pacientes que chega com consulta prescrita do médico da UBS, faz a triagem e a triagem encaminha direto para a medicação)",
	[AttendanceStatus.MATERNITY_CONSULTATION]: "Consultório Maternidade",
	[AttendanceStatus.MATERNITY_CLASSIFICATION]: "Classificação Maternidade",
	[AttendanceStatus.FORWARDED_TO_PROCEDURES_ROOM]: "Encaminhado para a Sala de Procedimentos",
	[AttendanceStatus.RISK_RECLASSIFICATION]: "Reclacificação de Risco",
	[AttendanceStatus.AWAITING_MEDICATION]: "Aguardando Medicação",
	[AttendanceStatus.PEDIATRIC_OBSERVATION]: "Observação Pediátrica",
	[AttendanceStatus.AWAITING_MATERNITY_MEDICATION]: "Aguardando Medicação Maternidade",
	[AttendanceStatus.MATERNITY_OBSERVATION]: "Observação Maternidade",
	[AttendanceStatus.MATERNITY_RETURN]: "Retorno Maternidade",
	[AttendanceStatus.MEDICAL_RETURN]: "Retorno Médico",
	[AttendanceStatus.EVASION_TRIAGE]: "Evasao Triagem",
	[AttendanceStatus.INTERNED]: "Internado",
	[AttendanceStatus.FINISHED]: "Finalizado (Alta)",
	[AttendanceStatus.EXTERNAL_REFERRAL]: "ENCAMINHAMENTO EXTERNO",
	[AttendanceStatus.CALLING_ON_SCREEN]: "Chamando na tela",
	[AttendanceStatus.IN_CONSULTATION_ATTENDANCE]: "Em atendimento Consultorio",
	[AttendanceStatus.CONSULTATION_EVASION]: "Evasao Consultorio",
	[AttendanceStatus.EVASION]: "Evasao",
	[AttendanceStatus.PATIENT_DEATH]: "ÓBITO PACIENTE",
	[AttendanceStatus.ADMINISTRATIVE_DISCHARGE]: "ALTA ADMINISTRATIVA",
	[AttendanceStatus.RECLASSIFIED]: "RECLASSIFICADO",
	[AttendanceStatus.REVALUATE_AFTER_MEDICATION]: "Reavaliar Após Médicamento",
	[AttendanceStatus.ATTENDED_SPA]: "ATENDIDO SPA",
	[AttendanceStatus.ATTENDED_MATERNITY_SPA]: "ATENDIDO MATERNIDADE SPA",
	[AttendanceStatus.AWAITING_PEDIATRIC_MEDICATION]: "Aguardando Medicação Pediatria",
	[AttendanceStatus.RETURN_PEDIATRICS]: "Retorno Pediatria",
	[AttendanceStatus.ATTENDED_SPA_PEDIATRICS]: "ATENDIDO Pediatria SPA",
	[AttendanceStatus.RETURN_WITH_SADT]: "RETORNO COM SADT",
	[AttendanceStatus.SEND_TO_ISOLATION]: "ENCAMINHAR AO ISOLAMENTO",
	[AttendanceStatus.DISCHARGE_AFTER_MEDICATION]: "Alta Após Médicação",
	[AttendanceStatus.RETURN_AFTER_MEDICATION]: "Retorno Após Médicação",
	[AttendanceStatus.RETURN_AFTER_MEDICATION_WITH_SADT]: "RETORNO APOS MEDICACAO COM SADT",
	[AttendanceStatus.ADULT_INTERNMENT]: "Internamento Adulto",
	[AttendanceStatus.PEDIATRIC_INTERNMENT]: "Internamento Pediatrico",
	[AttendanceStatus.MATERNITY_INTERNMENT]: "Internamento Maternidade",
	[AttendanceStatus.DISCHARGE_AFTER_MEDICATION_MATERNITY]: "Alta Após Médicação - Maternidade",
	[AttendanceStatus.RETURN_AFTER_MEDICATION_MATERNITY]: "Retorno Após Médicação - Maternidade",
	[AttendanceStatus.RETURN_WITH_SADT_MATERNITY]: "RETORNO COM SADT - Maternidade",
	[AttendanceStatus.RETURN_AFTER_MEDICATION_WITH_SADT_MATERNITY]:
		"RETORNO APOS MEDICACAO COM SADT - Maternidade",
	[AttendanceStatus.RETURN_AFTER_PROCEDURES]: "RETORNAR APÓS PROCEDIMENTOS",
	[AttendanceStatus.RETURN_AFTER_MATERNITY_PROCEDURES]: "RETORNAR APÓS PROCEDIMENTOS MATERNIDADE",
	[AttendanceStatus.AWAITING_ELECTIVE_LABORATORY_EXAMS]: "Aguardando Exame Eletivo Laborátorio",
	[AttendanceStatus.ELECTIVE_LABORATORY_EXAM_ATTENDED]: "Atendido Exame Eletivo Laborátorio",
	[AttendanceStatus.EVASION_PROCEDURES]: "Evasão Sala de Pocedimentos",
	[AttendanceStatus.ADULT_OBSERVATION_HOSPITAL]: "Observação Adulta - Hospital",
	[AttendanceStatus.PEDIATRIC_OBSERVATION_HOSPITAL]: "Observação Pediátrica - Hospital",
	[AttendanceStatus.AWAITING_ELECTIVE_RADIOGRAPHY_EXAMINATION]:
		"Aguardando Exame Eletivo Radiografia",
	[AttendanceStatus.ATTENDED_ELECTIVE_EXAMINATION_RADIOGRAPHY]:
		"Atendido Exame Eletivo Radiografia",
	[AttendanceStatus.INTERNMENT_MEDICAL_DISCHARGE]: "Alta Médica Internamento",
	[AttendanceStatus.OBSERVATION_DISCHARGE]: "Alta Médica Observação",
	[AttendanceStatus.RED_ROOM_DISCHARGE]: "Alta Médica Sala Vermelha",
	[AttendanceStatus.OBSERVATION]: "Observação (Setor somente Observação)",
	[AttendanceStatus.BRIEF_OBSERVATION]: "Observação Breve",
	[AttendanceStatus.SURGICAL_CENTER]: "Centro Cirúrgico Ambulatorial",
	[AttendanceStatus.AWAITING_SURGICAL_CENTER]: "Aguardando Centro Cirúrgico Ambulatorial",
	[AttendanceStatus.RADIOGRAPHY_EVASION]: "Evasão Radiografia",
	[AttendanceStatus.CODIV_19_SYMPTOMS]: "SINTOMAS CODIV19",
	[AttendanceStatus.CODIV_19_SUSPECT]: "SUSPEITA CODIV19",
	[AttendanceStatus.ATTENDANCE_DISCARDED]: "DESCARTADO ATENDIMENTO",
	[AttendanceStatus.CASE_CONFIRMED]: "CASO CONFIRMADO",
	[AttendanceStatus.RECOVERED]: "RECUPERADO",
	[AttendanceStatus.DEATH]: "ÓBITO",
	[AttendanceStatus.EXAMINATION_DISCARDED]: "DESCARTADO EXAME",
	[AttendanceStatus.RESIDENTIAL_INSOLATION]: "ISOLAMENTO RESIDENCIAL",
	[AttendanceStatus.HOSPITAL_ISOLATION]: "ISOLAMENTO HOSPITALAR",
	[AttendanceStatus.TRANSFER]: "TRANSFERIR",
	[AttendanceStatus.START_AND_CLASSIFY_COVID_19]: "Iniciar e classificar Covid-19",
	[AttendanceStatus.COVID_19_CLASSIFICATION]: "Classificação Covid-19",
	[AttendanceStatus.COVID_19_CONSULTATION]: "Consultório Covid-19",
	[AttendanceStatus.SPECIALTY_CONSULTATION]: "Consultório Especialidade",
	[AttendanceStatus.SPECIALTY_CONSULTATION_EVASION]: "Evasão Consultório Especialidade",
	[AttendanceStatus.SEND_FOR_ADULT_INTERNMENT]: "ENCAMINHAR PARA INTERNAMENTO ADULTO",
	[AttendanceStatus.RETURN_WITH_SADT_COVID]: "RETORNO COM SADT COVID",
	[AttendanceStatus.SEND_TO_COVID_ISOLATION]: "ENCAMINHAR AO ISOLAMENTO COVID",
	[AttendanceStatus.DISCHARGE_AFTER_COVID_MEDICATION]: "Alta Após Médicação Covid",
	[AttendanceStatus.RETURN_AFTER_COVID_MEDICATION]: "Retorno Após Médicação Covid",
	[AttendanceStatus.RETURN_AFTER_MEDICATION_WITH_SADT_COVID]:
		"RETORNO APOS MEDICACAO COM SADT COVID",
	[AttendanceStatus.FINISHED_COVID]: "Finalizado (Alta) Covid",
	[AttendanceStatus.PEDIATRIC_INTERNMENT_COVID]: "internamento Pediátrica",
	[AttendanceStatus.CONSULTATION_EVASION_COVID]: "Evasao Consultorio Covid",
	[AttendanceStatus.AWAITING_CONSULTATION_TELEMEDICINE]: "Aguardando Consulta (Telemedicina)",
	[AttendanceStatus.IN_ATTENDANCE_TELEMEDICINE]: "Em atendimento (Telemedicina)",
	[AttendanceStatus.FINISHED_HIGH_TELEMEDICINE]: "Finalizado (Alta) Telemedicina",
	[AttendanceStatus.CANCELLATION_DISMISSED_TELEMEDICINE]: "DESCARTADO ATENDIMENTO (Telemedicina)",
};
